module.exports = __webpack_public_path__ + "static/img/10023.807c8cb2.png";